{
  "page": {
    "eyebrow": "Moderation",
    "title": "Admin dashboard",
    "subtitle": "Review listings, orders, disputes, users and platform health.",
    "loading": "Loading…"
  },
  "tabs": {
    "overview": "Dashboard",
    "users": "Users",
    "sellers": "Sellers",
    "sellersReview": "Seller review",
    "auctions": "Auctions",
    "orders": "Orders",
    "payments": "Payments",
    "payouts": "Payouts",
    "shipments": "Shipments",
    "disputes": "Disputes",
    "reports": "Reports",
    "settings": "Settings",
    "reviews": "Reviews",
    "financial": "Financial",
    "health": "System health",
    "webhooks": "Webhooks",
    "audit": "Audit log",
    "promotions": "Featured promos",
    "aiAnalytics": "AI analytics",
    "marketData": "Market data",
    "cron": "Cron health",
    "push": "Push health",
    "cardMaster": "Card master",
    "emailCentre": "Email Centre",
    "advertising": "Advertising & Partners",
    "homepageStats": "Homepage Statistics",
    "newsletter": "Newsletter",
    "community": "Community",
    "events": "Events",
    "articles": "Articles",
    "dealers": "Dealers",
    "sellerTrust": "Seller Trust",
    "launch": "Launch checklist",
    "stripe": "Stripe debug"
  },
  "overview": {
    "title": "Platform overview",
    "subtitle": "Snapshot of activity across BidNova Auctions.",
    "loading": "Loading overview…",
    "error": "Failed to load overview.",
    "totalUsers": "Total users",
    "activeSellers": "Active sellers",
    "approvedSellers": "Approved sellers",
    "liveAuctions": "Live auctions",
    "orders": "Orders",
    "ordersLive": "{count} live",
    "grossSales": "Gross sales",
    "pendingPayouts": "Pending payouts",
    "shipments": "Shipments",
    "activeDisputes": "Active disputes"
  }
}
